import { RepairTypeId } from '@service-initiation/shared-clients-tech-care-services';

import { type Repair } from '../types';

export const sortRepairOptions = (repairs?: Repair[]) =>
  repairs?.sort((a, b) => {
    if (
      a.repairType.id === RepairTypeId.CrackedScreen ||
      b.repairType.id === RepairTypeId.IDontKnow
    ) {
      return -1;
    }
    if (
      a.repairType.id === RepairTypeId.IDontKnow ||
      b.repairType.id === RepairTypeId.CrackedScreen
    ) {
      return 1;
    }
    return (
      (a.sortOrder === 0 ? Infinity : a.sortOrder) -
      (b.sortOrder === 0 ? Infinity : b.sortOrder)
    );
  });
